import { convertCartItemToGAItem, getTotalValue } from "./common"

export const trackPurchase = item => {
  if (window?.dataLayer) {
    if (!item.itemList) return
    const items = item.itemList.map((item, index) => {
      const result = {
        ...item,
        index,
        quantity: Number(item.wareCount)
      }
      if (item.promotionId) {
        return {
          ...result,
          wareNameWithPromotionId: `${item.promotionId} ${item.wareName}`,
          wareIdWithPromotionId: `${item.promotionId} ${item.wareId}`
        }
      }
      return result
    })
    window.dataLayer.push({
      event: "purchase",
      // rewards_point: $rewards_point,
      // rewards_value: $rewards_value,
      ecommerce: {
        currency: "SGD",
        value: item.orderPrice / 100,
        coupon: item.useCouponId,
        payment_type: item.paymentTypeName,

        shipping_tier: item.shipmentTypeName || "next day delivery",
        shipping_address: item.consignee.fullAddress,
        transaction_id: String(item.orderId),
        shipping: item.freightFee / 100,
        tax: item.taxNum,
        items: items.map(convertCartItemToGAItem)
      }
    })
  }
}

export const trackAddPaymentInfo = (items, coupons = [], totleValue) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "add_payment_info",
      ecommerce: {
        currency: "SGD",
        value: totleValue / 100,
        coupon: coupons.join(",") || "na",
        payment_type: "credit card",
        items: items.map(convertCartItemToGAItem)
      }
    })
  }
}
